import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');
const Create = () => import('./Create.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-templates'),
      component: SettingsWrapper,
      props: {
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'settings_whatsapp_templates',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'settings_whatsapp_templates_new',
          component: Create,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          // Mesma tela do builder: o que muda e de onde os dados vem e o que o envio faz.
          // O `templateId` e o id daquele IDIOMA do template, nao do nome.
          path: ':templateId/edit',
          name: 'settings_whatsapp_templates_edit',
          component: Create,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
